import { DictUtil } from 'jczh-ui'

// 不同验证码短信的模板
export const templateCodeObj = {
  register: 'register_verification_code_sms',
  login: 'login_verification_code_sms',
  forgetPwd: 'forget_password_verification_code_sms',
  changeMobile: 'change_old_mobile_verification_code_sms',
  bindMobile: 'bind_mobile_verification_code_sms'
}

export const employeeStatusDict = new DictUtil({
  DISABLED: {
    label: '禁用',
    value: 0,
    type: 'danger'
  },
  NORMAL: {
    label: '正常',
    value: 1,
    type: 'primary'
  }
})

export const companyStatusDict = new DictUtil({
  DISABLED: {
    label: '禁用',
    value: 0,
    type: 'danger'
  },
  NORMAL: {
    label: '正常',
    value: 1,
    type: 'primary'
  }
})

// 广告别名
export const bannerAliasDict = new DictUtil({
  PASSPORT_BANNER: { label: '登录中心首页banner', value: 'PASSPORT_BANNER' }
})
